import {Button} from "../Button";
import React from "react";

export default function SavingPopupContext(props) {
    const {handlePopup, cancelBtn, saveBtn, okBtn, context_data } = props;

    const handleClickFactory = (e) => {
        const buttonName = e.target.name

        if (buttonName === 'save') {
            return handlePopup({
                type: "save",
                context_data: context_data
            })
        }
        if (buttonName === 'cancel') {
            return handlePopup({type: "cancel"})
        }
        if (buttonName === 'ok') {
            return handlePopup({type: "ok"})
        }
    };

    return (<>
        {cancelBtn ? (<Button name="cancel" onClick={(e) => handleClickFactory(e)} variant="round" bWidth="small" styling="bordered" className='mx-3'>{cancelBtn}</Button>):null}
        {saveBtn ? (<Button name="save" onClick={(e) => handleClickFactory(e)} variant="round" bWidth="small" styling="plain" className='mx-3'>{saveBtn}</Button>):null}
        {okBtn ? (<Button name="OK" onClick={(e) => handleClickFactory(e)} variant="round" bWidth="small" styling="plain" className='mx-3'>{okBtn}</Button>):('')}
    </>)
}